import React from "react"
import { H1 } from '../components/headings/index'
import Layout from "../components/layout/index"
import SEO from "../components/seo"
import Container from '../components/container/index'
import { InternalHeader } from '../components/partials/style'
import FormContato from '../components/contactForm/index'

const Contato = props => {

  return (
    <Layout paintHeader={true}>
      <SEO 
        title="Contato" 
        description="Entre em contato com a gente"
        url="/contato"
        image={'/images/share/square.jpg'}
      />
      <Container>
        <InternalHeader>
          <H1>Entre em <span>Contato</span></H1>
          {/* <H5 weight={'normal'}>Lorem ipsum dolor sit amet consectetuer adipiscing elit</H5> */}
        </InternalHeader>

        <FormContato />
      </Container>
    </Layout>
  )
}

export default Contato
